import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import useInternationalization from '../../hooks/useInternationalization';
import styles from './ComingSoon.module.css';

const ComingSoon = (): JSX.Element => {
  const { getIntlText } = useInternationalization();
  const { darkMode } = useSelector((state: RootState) => state.settings);

  return (
    <div className={`${styles.container} ${darkMode && styles.containerDarkMode}`}>
      <div className={styles.content}>
        <div className={styles.icon}>📹</div>
        <div className={styles.message}>{getIntlText('coming_soon')}</div>
        <div className={styles.submessage}>
          Videos for this book are being prepared and will be available soon.
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
